<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 bg-gradient-primary shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-md-3">
                <card
                  class="border-0 d-flex card-walet"
                  hover
                  shadow
                  body-classes="text-center align-items-center d-flex justify-content-center"
                >
                  <object
                    data="/img/svg/11-wallet.svg"
                    type="image/svg+xml"
                    class="text-white card-pajak"
                  ></object>
                  <h6
                    class="text-white text-uppercase title-inside-card"
                    style="margin-top: 7px"
                  >PAJAK SARANG BURUNG WALET</h6>
                </card>
              </div>
              <div class="col-lg-8">
                <h1 class="display-3 text-white">
                  Pelayanan Walet
                  <span>Kabupaten Ketapang</span>
                </h1>
                <p class="description mt-3 text-white">
                  Pajak Sarang Burung Walet adalah pajak atas kegiatan
                  pengambilan dan/atau pengusahaan sarang burung walet. Objek
                  pajaknya adalah pengambilan dan/atau pengusahaan sarang burung
                  walet. Subjek pajaknya adalah orang pribadi atau badan yang
                  melakukan pengambilan dan/atau pengusahaan sarang burung
                  walet.
                </p>

                <p class="description mt-3 text-white">
                  Dasar Pengenaan Pajak (DPP) Sarang Burung Walet adalah nilai
                  jual sarang burung walet. Nilai jual sarang burung walet
                  dihitung berdasarkan perkalian antara harga pasaran umum
                  sarang burung walet dengan volume sarang burung walet. Harga
                  pasaran umum sarang burung walet ditetapkan dengan Peraturan
                  Bupati. Tarif pajak sarang burung walet ditetapkan sebesar 10%
                  (sepuluh persen).
                </p>

                <div class="btn-wrapper">
                  <base-button
                    tag="a"
                    class="mb-3 mb-sm-0"
                    type="info"
                    textColor="white"
                    icon="fa fa-arrow-left"
                    @click="goback()"
                  >Kembali</base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <br />
    <br />
    <section class="section section-lg pt-lg-0 mt--200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-md-3" v-if="checkAkses">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-save" type="success" rounded class="mb-4"></icon>
                  <h6 class="text-success text-uppercase">E-SPTPD</h6>
                  <p class="description mt-3">Pendataan SPTPD Pajak Burung Walet secara Online.</p>
                  <base-button
                    textColor="white"
                    tag="a"
                    type="success"
                    class="mt-4"
                    @click="goSptpdPajak()"
                  >E-SPTPD</base-button>
                </card>
              </div>
              <div class="col-md-3">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-cog" type="warning" rounded class="mb-4"></icon>
                  <h6 class="text-warning text-uppercase">Peraturan Pajak Walet</h6>
                  <p class="description mt-3">
                    Dasar Hukum pemungutan Pajak Walet yang termuat dalam
                    undang-undang.
                  </p>
                  <base-button
                    tag="a"
                    textColor="white"
                    type="warning"
                    class="mt-4"
                    @click="goDasarHukum()"
                  >Dasar Hukum</base-button>
                </card>
              </div>
              <div class="col-md-3" v-if="checkAkses">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-cog" type="danger" rounded class="mb-4"></icon>
                  <h6 class="text-danger text-uppercase">Cetak SSPD</h6>
                  <p class="description mt-3">Cetak SSPD Pajak Burung Walet.</p>
                  <br />
                  <base-button
                    tag="a"
                    textColor="white"
                    type="warning"
                    class="mt-4"
                    @click="cetakSSPD()"
                  >Cetak</base-button>
                </card>
              </div>
              <div class="col-md-3" v-if="checkAkses">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-print" type="success" rounded class="mb-4"></icon>
                  <h6 class="text-success text-uppercase">Informasi Pajak Walet</h6>
                  <p
                    class="description mt-3"
                  >Melihat Informasi Pajak Hotel berdasarkan NPWPD pemilik usaha.</p>
                  <base-button
                    textColor="white"
                    tag="a"
                    type="success"
                    class="mt-4"
                    @click="goPWalet()"
                  >Informasi Pajak</base-button>
                </card>
              </div>
            </div>
          </div>
        </div>

        <br />
        <br />
        <div class="row">
          <div class="col-md-12">
            <highcharts :options="chartOptions"></highcharts>
          </div>
        </div>
      </div>
    </section>
    <modal-informasi-pajak
      ref="modal-informasi-pajak"
      title="Pencarian Informasi Pajak Walet"
      code="1109"
      url="/api/v1/pajak-daerah"
    ></modal-informasi-pajak>

    <modal :show.sync="dasar_hukum" footerClasses="text-right" :largeModal="true">
      <h6
        slot="header"
        class="modal-title text-success font-weight-bold"
        id="modal-title-default"
      >Dasar Hukum Pajak Walet</h6>
      <div class="d-block">
        <div
          class="clearfix text-formatted field field--name-body field--type-text-with-summary field--label-hidden field__item"
        >
          <p>
            Ditinjau dari segi lembaga pemungutnya, pajak dapat dibagi menjadi 2
            (dua) jenis, yaitu Pajak Pusat dan Pajak Daerah. Pajak Penghasilan
            (PPh) termasuk dalam jenis pajak pusat. Sesuai Undang-Undang nomor 28
            Tahun 2009 tentang Pajak Daerah dan Retribusi Daerah, jenis pajak
            daerah dibagi menjadi 2 (dua), antara lain Pajak Provinsi dan Pajak
            Kabupaten/Kota. Pajak Sarang Burung Walet termasuk dalam jenis Pajak
            Kabupaten/Kota.
          </p>
          <p>
            Pasal 2 ayat (1) Peraturan Pemerintah (PP) nomor 23 tahun 2018,
            disebutkan atas penghasilan dari usaha yang diterima atau diperoleh
            Wajib Pajak Dalam Negeri (WPDN) yang memiliki peredaran bruto
            tertentu, dikenai Pajak Penghasilan yang bersifat final dalam jangka
            waktu tertentu. Yang menjadi objek adalah penghasilan dari usaha yang
            diterima atau diperoleh wajib pajak.
          </p>
          <p>
            WPDN yang memiliki peredaran bruto tertentu adalah wajib pajak orang
            pribadi; dan wajib pajak badan berbentuk koperasi, persekutuan
            komanditer, firma, atau perseroan terbatas yang menerima atau
            memperoleh penghasilan dengan peredaran bruto tidak melebihi
            Rp4.800.000.000,00 (empat miliar delapan ratus juta rupiah) dalam 1
            (satu) tahun pajak.&nbsp;
          </p>
          <p>
            <span style="font-size: 13.008px">
              Besarnya peredaran bruto tertentu merupakan jumlah peredaran bruto
              dalam 1 (satu) tahun dari tahun pajak terakhir sebelum tahun pajak
              bersangkutan, yang ditentukan berdasarkan keseluruhan peredaran
              bruto dari usaha, termasuk peredaran bruto dari cabang.
            </span>
          </p>
          <p>
            Dalam hal wajib pajak orang pribadi merupakan suami-istri yang
            menghendaki perjanjian pemisahan harta dan penghasilan secara
            tertulis; atau istrinya menghendaki memilih untuk menjalankan hak dan
            kewajiban perpajakannya sendiri, besarnya peredaran bruto ditentukan
            berdasarkan penggabungan peredaran bruto usaha dari suami dan istri.
          </p>
          <p>
            <span
              style="
              font-family: Arial, sans-serif;
              font-size: 11pt;
              text-align: justify;
              text-indent: 36pt;
            "
            >
              Dasar Pengenaan Pajak (DPP) yang digunakan untuk menghitung PPh
              yang bersifat final adalah jumlah peredaran bruto setiap bulan.
              Peredaran bruto yang dijadikan dasar pengenaan pajak merupakan
              imbalan atau nilai pengganti berupa uang atau nilai uang yang
              diterima atau diperoleh dari usaha, sebelum dikurangi potongan
              penjualan, potongan tunai, dan/atau potongan sejenis. Besarnya tarif
              PPh yang bersifat final adalah
            </span>
            <span style="font-family: 'Arial', 'sans-serif'">0,5% (nol koma lima persen).</span>
          </p>
          <p>
            <span
              style="
              font-family: Arial, sans-serif;
              font-size: 11pt;
              text-align: justify;
              text-indent: 36pt;
            "
            >
              Pajak Sarang Burung Walet adalah pajak atas kegiatan pengambilan
              dan/atau pengusahaan sarang burung walet. Objek pajaknya adalah
              pengambilan dan/atau pengusahaan sarang burung walet. Subjek
              pajaknya adalah orang pribadi atau badan yang melakukan pengambilan
              dan/atau pengusahaan sarang burung walet.
            </span>
          </p>
          <p>
            <span
              style="
              font-family: Arial, sans-serif;
              font-size: 11pt;
              text-align: justify;
              text-indent: 36pt;
            "
            >
              Dasar Pengenaan Pajak (DPP) Sarang Burung Walet adalah nilai jual
              sarang burung walet. Nilai jual sarang burung walet dihitung
              berdasarkan perkalian antara harga pasaran umum sarang burung walet
              dengan volume sarang burung walet. Harga pasaran umum sarang burung
              walet ditetapkan dengan Peraturan Bupati. Tarif pajak sarang burung
              walet ditetapkan sebesar 10% (sepuluh persen).
            </span>
          </p>
          <p>
            <span
              style="
              font-family: Arial, sans-serif;
              font-size: 11pt;
              text-align: justify;
              text-indent: 36pt;
            "
            >
              Contoh kasus: Tuan Radya, seorang pengusaha yang bergerak dalam
              pengusahaan sarang burung walet, termasuk kategori WP PPh Final PP
              23/2018. Pada bulan Desember 2018 hasil panennya adalah 30 kg dengan
              harga jual Rp15 juta per kg. Sesuai ketentuan, Tuan Radya wajib
              membayar pajak pusat (Pajak Penghasilan) dan pajak daerah (Pajak
              Sarang Burung Walet).
            </span>
          </p>
          <p>
            <span
              style="
              font-family: Arial, sans-serif;
              font-size: 11pt;
              text-align: justify;
              text-indent: 36pt;
            "
            >
              Perhitungan pengenaan pajak sebagai berikut: i) menyetor PPh Final
              PP 23/2018 sebesar Rp2.250.000,- (dengan perhitungan 30 kg x Rp15
              juta x 0,5 %); ii) menyetor Pajak Sarang Burung Walet sebesar
              Rp45.000.000,- (dengan perhitungan 30 kg x Rp15 juta x 10 %).
            </span>
          </p>
          <p>
            <span
              style="
              font-family: Arial, sans-serif;
              font-size: 11pt;
              text-align: justify;
              text-indent: 36pt;
            "
            >
              Dari penjelasan di atas, terlihat bahwa baik PPh Final PP 23/2018
              maupun Pajak Sarang Burung Walet sama-sama bersifat sederhana,
              sehingga memudahkan wajib pajak dalam melaksanakan kewajiban
              perpajakannya. Kesamaan lainnya, yaitu: Subjek Pajak, Objek Pajak,
              Dasar Pengenaan Pajak (DPP), dan tarifnya tunggal (tidak
              proporsional).
            </span>
            <span
              style="
              background-color: #fffff3;
              font-family: 'Helvetica Nueue', 'Trebuchet MS', Arial,
                'Nimbus Sans L', FreeSans, sans-serif;
              font-size: 12px;
            "
            >(*)</span>
          </p>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import ModalInformasiPajak from "../GlobalPage/InformasiPajak";
import { Chart } from "highcharts-vue";
import axios from "axios";
import Modal from "@/components/Modal.vue";
export default {
  name: "walet",
  components: {
    ModalInformasiPajak,
    highcharts: Chart,
    Modal,
  },
  data() {
    return {
      items: [],
      dasar_hukum: false,
    };
  },
  computed: {
    checkAkses() {
      if (this.$store.state.auth.status.loggedIn)
        if (this.$store.state.auth.user.is_wajib_pajak)
          return this.$store.state.auth.user.registrations.find((item) => item.business_id == 9)
        else
          return this.$store.state.auth.user.business_id == 9;
      return false;
    },
    chartOptions() {
      return {
        chart: {
          type: "column",
        },
        title: {
          text: "Realisasi Pajak Burung Walet berdasarkan Tahun",
        },
        subtitle: {
          text: "Data tahun yang di ambil adalah data 10 tahun kebelakang.",
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          title: {
            text: "Jumlah Realisasi",
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: "{point.y:.2f}",
            },
          },
        },

        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>',
        },

        series: [
          {
            name: "Tahun",
            colorByPoint: true,
            data: this.items,
          },
        ],
      };
    },
  },
  created() {
    this.getRealisasi();
  },
  methods: {
    async getRealisasi() {
      try {
        this.isBusy = true;
        let { data } = await axios.get("/api/v1/realisasi/walet");

        var items = [];
        for (const [key, value] of Object.entries(data)) {
          this.items.push({
            name: value.tahun_realisasi,
            y: parseFloat(value.realisasi),
          });
        }
      } catch (error) {
        // console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    goSptpdPajak() {
      this.$router.push("/burung-walet/e-sptpd");
    },
    goWajibPajak() {
      this.$router.push("/burung-walet/daftar");
      // this.$refs["modal-wajib-pajak"].showModal();
    },
    goWajibPajakCheck() {
      this.$refs["modal-wajib-pajak"].showModal();
    },
    goPWalet() {
      this.$refs["modal-informasi-pajak"].showModal();
    },
    goDasarHukum() {
      this.dasar_hukum = true;
    },
    goback() {
      this.$router.go(-1);
    },
    cetakSSPD() {
      this.$router.push("/burung-walet/pembayaran");
    },
  },
};
</script>
<style lang="scss" scoped>
.section-shaped .shape.shape-skew + .shape-container {
  padding-top: 9rem;
  padding-bottom: 14rem;
}

.card-walet {
  height: 100%;
}
</style>